import React from 'react';
import { Table } from 'react-bootstrap';

/**
 * SkippedUsersTable component displays a table of users that were skipped during import.
 * @component
 * @param {Object[]} skippedUsers - Array of skipped user objects.
 * @param {number} skippedUsers[].row - The row number in the Excel file where the user was skipped.
 * @param {string} skippedUsers[].email - The email address of the skipped user.
 * @param {string} skippedUsers[].reason - The reason why the user was skipped.
 * @returns {JSX.Element|null} A table of skipped users, or null if there are no skipped users.
 */

const SkippedUsersTable = ({ skippedUsers }) => {
  if (!skippedUsers || skippedUsers.length === 0) return null;

  return (
    <div className="mb-3">
      <h6 style={{ color: '#F7C46C', fontSize: '16px' }}>Skipped Users</h6>
      <Table 
        striped 
        bordered 
        hover 
        size="sm"
        style={{ 
          backgroundColor: 'rgba(116, 232, 199, 0.05)',
          color: 'white',
          borderColor: '#74E8C7'
        }}
      >
        <thead style={{ backgroundColor: 'rgba(116, 232, 199, 0.1)' }}>
          <tr>
            <th style={{ color: '#74E8C7', borderColor: '#74E8C7' }}>Row</th>
            <th style={{ color: '#74E8C7', borderColor: '#74E8C7' }}>Email</th>
            <th style={{ color: '#74E8C7', borderColor: '#74E8C7' }}>Reason</th>
          </tr>
        </thead>
        <tbody>
          {skippedUsers.map((skipped, index) => (
            <tr key={index} style={{ borderColor: '#74E8C7' }}>
              <td style={{ color: 'white', borderColor: '#74E8C7' }}>{skipped.row}</td>
              <td style={{ color: 'white', borderColor: '#74E8C7' }}>{skipped.email}</td>
              <td style={{ color: '#F7C46C', borderColor: '#74E8C7' }}>{skipped.reason}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default SkippedUsersTable;